<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
        新增区域表
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="区域名称" prop="area_name" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.area_name" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属单位" prop="c_number" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-select v-model="form.c_number" filterable>
              <el-option v-for="item in units" :key="item.c_company_num" :label="item.c_name" :value="item.c_company_num"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="区域地址" prop="area_addr" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.area_addr"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="18">
          <el-form-item label="区域CRT图纸">
            <el-upload action="." :http-request="upload" list-type="picture-card" :on-change="filechange" :limit="1" :fileList="$route.query.id ? fileList : null">
              <!-- :on-preview=""
              :on-remove="" -->
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="备注">
            <el-input v-model="form.area_remark" type="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="btn-box">
        <div class="l-btn" @click="onSubmit">保存</div>
        <div class="l-btn ml20" @click="$router.back()">返回</div>
      </div>
    </el-form>
  </div>
</template>

<script>
// import getLoation from './getLoation'
import OSS from "ali-oss";

export default {
  components: {},
  data() {
    return {
      form: {
        area_name: "",
        c_number: "",
        area_addr: "",
        image_name: "",
        area_remark: "",
      },
      fileList: [],
      units: [],
      // infoOpts:["水位","水压","电气火灾监控设备","用户信息传输装置","无线烟感","RTU","其他"],

      rules: {},
    };
  },
  created() {
    this.$post("/devicemanage/selectconpanybyme", {
      c_belong_profession: 174,
    }).then((res) => {
      this.units = res.data;
    });
    if (this.$route.query.id) {
      this.$post(`/crt/areadetail/${this.$route.query.id}`).then((res) => {
        this.form = res.data;
        if ((this.form.area_remark = "")) {
          this.$message.warning("请填写备注");
        }
        if (res.data.image_name) {
          this.fileList.push({ name: "图片" + 1, url: res.data.image_name });
        }
      });
    }
  },
  methods: {
    //上传
    filechange(file, fileList) {},
    upload(val) {
      //   return
      let client = new OSS(this.$bus.config.ossConfig);
      let file = val.file;
      let _this = this;
      let id = this.$bus.config.upload + "/t" + Date.now() + "s" + file.size + "/" + file.name;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        time: 0,
        progress: 0,
        key: id,
        client: client,
      });
      // _this.getTimes(file, id)

      // 定义上传方法。
      function multipartUpload() {
        _this.fileList[id].client
          .multipartUpload(id, file, {
            checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
            progress: (p, checkpoint, res) => {
              //log(p,checkpoint,res)
              if (checkpoint) {
                _this.fileList[id].progress = p * 100;
                _this.fileList[id].data = checkpoint;
              }
            },
            partSize: 1000 * 1024, //设置分片大小
            timeout: 120000, //设置超时时间
            mime: val.type,
          })
          .then((res) => {
            _this.fileList[id].progress = 100;
            _this.fileList[id].uploading = false;
            _this.$notify({
              title: "上传成功",
              message: `${_this.fileList[id].name}上传完成`,
              type: "success",
            });
            _this.form.image_name = `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`;
            var fileList = [{ name: _this.fileList[id].name, url: _this.form.image_name }];
            _this.fileList = fileList;

            // var stobj = {tr_task_id:_this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
            // _this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{

            //     _this.getList()
            // })
          })
          .catch((err) => {
            if (err.code == "RequestError" || err.code == "ConnectionTimeoutError") {
              //网络错误或超时
              setTimeout(multipartUpload, 3000);
            }
          });
      }

      multipartUpload();
    },
    // uploadSuccess(res, file, fileList) {
    //   log(res, file, fileList);
    //   var arr = [];
    //   fileList.forEach((it) => {
    //     if (it.response) {
    //       arr.push(...it.response.image_uuid);
    //     } else if (it.url) {
    //       arr.push(it.url);
    //     }
    //   });
    //   this.fileList = [];
    //   arr.forEach((it, index) => {
    //     this.fileList.push({ name: "附件" + (index + 1), url: it });
    //   });
    //   this.form.picname = arr;
    // },
    // removeFile(file, fileList) {
    //   var arr = [];
    //   fileList.forEach((it) => {
    //     arr.push(it.url);
    //   });
    //   this.fileList = [];
    //   arr.forEach((it, index) => {
    //     this.fileList.push({ name: "附件" + (index + 1), url: it });
    //   });
    //   this.form.picname = arr;
    // },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    save() {
      console.log(this.form);
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      let api = this.$route.query.id ? "/crt/areaupdate" : "/crt/areainsert";
      this.$post(api, this.form)
        .then((res) => {
          // this.$message.success("保存成功");
          this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
          this.$router.back();
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped></style>
